(function () {
  
  /**
   * Close a quick-add panel, leaving focus somewhere reachable.
   *
   * The closed panel is visibility:hidden, so anything focused inside it — the
   * close button, a variant radio, the quantity input — gets blurred as it goes
   * and focus drops to <body>. Hand focus back to the button that opens the
   * panel, or to the card's title link when that button is disabled (which
   * card-variant-filter.js does when no variant matches the delivery preference).
   */
  function closePanel(panel) {
    if (!panel) { return; }

    if (panel.contains(document.activeElement)) {
      const card = panel.closest('.card');
      const trigger = card && card.querySelector('.card_quick-atc');
      const target = trigger && !trigger.disabled
        ? trigger
        : card && card.querySelector('.card__heading a');
      if (target) { target.focus({ preventScroll: true }); }
    }

    panel.classList.remove('active');
  }

  function removeActiveClassFromCards() {
    // 1. Select all elements that have BOTH classes.
    // The selector '.class1.class2' finds elements with both class1 and class2.
    const activeCards = document.querySelectorAll('.card_atc--content.active');

    console.log(`Found ${activeCards.length} element(s) to change.`);

    // 2. Loop through the found elements (if any) and close them.
    activeCards.forEach(card => {
      closePanel(card);
      console.log('Removed "active" class from:', card);
    });

    if (activeCards.length === 0) {
      console.log("No active cards found to update. (Try refreshing the page and clicking again).");
    }
  }

  class CardProduct extends HTMLElement {
  
    constructor() {
      // Always call super first in constructor
      super();

      const quickAtc = this.querySelector('.card_quick-atc');
      
      const quickAtcCloseButton = this.querySelector('.card_atc--close');
      const cardProductElement = this;
      quickAtc.addEventListener('click', function(e) {
        e.preventDefault();
        // Guard: do nothing if product has no matching variants for the delivery preference
        if (cardProductElement.classList.contains('card--store-unavailable')) return;
        console.log('cdebug quickatc', quickAtc);
        if(quickAtc.dataset.preorder) {
          document.location.href = quickAtc.dataset.url
        }
        removeActiveClassFromCards();
        quickAtc.closest('.card').querySelector('.card_atc--content').classList.add('active');

      })

      quickAtcCloseButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        closePanel(quickAtcCloseButton.closest('.card').querySelector('.card_atc--content'));

      })
    }
  }
  
  customElements.define("card-product", CardProduct);
})();